import { get, getViaAuth, responseValidator } from '../../apis/api';
import { API } from '../../apis';

export const getAllOrders = async (
    setLoading: any,
    setData: any,
    page: number,
    pageSize: number,
    query: string,
    setCount: any,
) => {
    setLoading(true);
    await getAllOrdersCount(setLoading, setCount, page, pageSize, query);
    await getViaAuth(`${API.order.getAll}/${page}/${pageSize}${query}`).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            setData(response.value);
        }
    });
};

export const getAllOrdersCount = (setLoading: any, setData: any, page: number, pageSize: number, query: string) => {
    setLoading(true);
    getViaAuth(`${API.order.getCount}/${page}/${pageSize}${query}`).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) setData(response.value);
    });
};

export const getMarketTypes = (setLoading: any, setData: any) => {
    setLoading(true);
    get(API.enum.getMarketTypes).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            setData([{ id: -1, title: 'نوع ارز' }, ...response.data.value]);
        }
    });
};

export const getOrderSides = (setLoading: any, setData: any) => {
    setLoading(true);
    get(API.enum.getOrderSides).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            setData([{ id: -1, title: 'انتخاب سمت معامله' }, ...response.data.value]);
        }
    });
};

export const getOrderState = (setLoading: any, setData: any) => {
    setLoading(true);
    get(API.enum.getOrderState).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            setData([{ id: -1, title: 'همه وضعیت ها' }, ...response.data.value]);
        }
    });
};

export const getOrderSources = (setLoading: any, setData: any) => {
    setLoading(true);
    get(API.enum.getOrderSources).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            setData([{ id: -1, title: 'همه مبدا ها' }, ...response.data.value]);
        }
    });
};

export const getOrderType = (setLoading: any, setData: any) => {
    setLoading(true);
    get(API.enum.getOrderType).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            setData([{ id: -1, title: 'همه سفارش ها' }, ...response.data.value]);
        }
    });
};

export const getOrderDetailById = async (
    setLoading: React.Dispatch<React.SetStateAction<boolean>>,
    setData: React.Dispatch<React.SetStateAction<any>>,
    setTimer: React.Dispatch<React.SetStateAction<any>>,
    id: string,
) => {
    setLoading(true);
    await getViaAuth(API.order.getDetails + `/${id}`).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            setData(response.value);
            setTimer(new Date(response?.value?.paymentDate).getTime() + 72 * 60 * 60 * 1000);
        } else if (response.status === 404) {
            setData(undefined);
        }
    });
};

export const getOrderDetailByTrackingCode = async (
    setLoading: React.Dispatch<React.SetStateAction<boolean>>,
    setData: React.Dispatch<React.SetStateAction<any>>,
    setTimer: React.Dispatch<React.SetStateAction<any>>,
    trackingId: string,
) => {
    setLoading(true);
    await getViaAuth(API.orders.searchByTrackingCode + `/${trackingId}`).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            setData(response.data);
            setTimer(new Date(response.data.paymentDate).getTime() + 72 * 60 * 60 * 1000);
        } else if (response.status === 404) {
            setData(undefined);
        }
    });
};
